/* ═══════════════════════════════════════════
   MSC Shop — Scroll Reveal + Interactions
   ═══════════════════════════════════════════ */

(function () {
  'use strict';

  var ROOT_SEL = '.msc-shop';
  var root = document.querySelector(ROOT_SEL);
  if (!root) return;

  var cards = root.querySelectorAll('[data-msc-shop-card]');
  if (!cards.length) return;

  /* ── Feature detection ───── */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion) {
    for (var i = 0; i < cards.length; i++) {
      cards[i].style.opacity = '1';
      cards[i].style.transform = 'none';
    }
    return;
  }

  /* ── MODULE 1: SCROLL REVEAL ───── */

  function initWithGSAP() {
    gsap.utils.toArray(cards).forEach(function (card, i) {
      gsap.fromTo(card,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          delay: i * 0.15,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: card,
            start: 'top 88%',
            once: true
          }
        }
      );
    });
  }

  function initWithObserver() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = Array.prototype.indexOf.call(cards, entry.target);
          setTimeout(function () {
            entry.target.classList.add('is-revealed');
          }, idx * 150);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    for (var j = 0; j < cards.length; j++) {
      observer.observe(cards[j]);
    }
  }

  function initReveal() {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      initWithGSAP();
    } else {
      initWithObserver();
    }
  }

  /* GSAP may load after this script — retry briefly */
  if (typeof gsap === 'undefined') {
    var retries = 0;
    var poll = setInterval(function () {
      retries++;
      if (typeof gsap !== 'undefined' || retries > 20) {
        clearInterval(poll);
        initReveal();
      }
    }, 100);
  } else {
    initReveal();
  }

})();
